import Big from "big.js";
import { ethers } from "ethers";

interface NumberFormatOptions {
  maximumFractionDigits?: number;
  notation?: "compact" | "standard";
  compactDisplay?: "short" | "long";
}

const defaultNumberFormatOptions: NumberFormatOptions = {
  maximumFractionDigits: 1,
  notation: "compact",
  compactDisplay: "short",
};

export const compareWithMaxUint = (number: bigint, decimals: number): string | Big => {
  if (number === ethers.MaxUint256) {
    return "∞";
  } else {
    return BNToDecimal(number, decimals);
  }
};

export const compactNumber = (number: number, options?: NumberFormatOptions): string => {
  const formatOptions = { ...defaultNumberFormatOptions, ...options };
  return new Intl.NumberFormat("en-US", formatOptions).format(number);
};

export const formatPercentage = (number: number, decimals: number = 2): string => {
  return (number * 100).toFixed(decimals);
};

export const convertToDays = (seconds: number): number => {
  const secondsInDay = 24 * 60 * 60;
  return seconds / secondsInDay;
};

export const BNToDecimal = (bigIntNum: bigint, decimals: number): Big => {
  return Big(Number(bigIntNum)).div(10 ** decimals);
};

export const hoursToDays = (hours: number | Big): Big => {
  return Big(hours).div(24);
};

export const arrayOfBNToDecimal = (value: bigint[], decimals: number): Big[] => {
  return value.map((i) => BNToDecimal(i, decimals));
};

export const toDecimal = (number: number | string): Big => {
  return Big(number);
};

export const decimalToBN = (number: number | Big, decimals: number = 6): bigint => {
  return ethers.parseUnits(number.toString(), decimals);
};

export const strToDec = (numberAsString: string): Big | undefined => {
  try {
    return new Big(numberAsString);
  } catch {
    return undefined;
  }
};

export const strToDecZ = (numberAsString: string): Big | number | undefined => {
  // If the value is zero returns "0" as integer, this is to avoid the fact (error IMO) that
  // !Big(0) === false
  try {
    const ret = new Big(numberAsString);
    if (ret.eq(0)) return 0;
    else return ret;
  } catch {
    return undefined;
  }
};

export const strToBN = (numberAsString: string, decimals: number = 6): bigint | undefined => {
  const dec = strToDec(numberAsString);
  if (dec === undefined) return undefined;
  return decimalToBN(dec, decimals);
};
